import { Link as LinkType } from '~/lib/data-contract';
import styles from './newsletter-area.module.css';
import { RawHtml } from '~/shared/components/RawHtml/RawHtml';
import { Button } from '~/shared/components';

type NewsletterAreaProps = {
    link?: LinkType;
    text?: string;
};

export const NewsletterArea = ({ text, link }: NewsletterAreaProps) => {
    return (
        <section className={styles.root}>
            <div className={styles.newsletter}>
                {text && <RawHtml html={text} />}
                {link?.url && (
                    <Button href={link.url} variant="secondary" target={link.target} hoverEffect>
                        {link.text}
                    </Button>
                )}
            </div>
        </section>
    );
};
